
      var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSign = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 120,
  viewBox: "0 0 44 44",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M33.277 32.786v6.063c0 .414-.137.81-.38 1.103-.243.292-.573.456-.917.456H7.297C6.58 40.408 6 39.71 6 38.85V4.56C6 3.698 6.58 3 7.297 3h18.585c.602 0 1.182.233 1.617.65l5.057 4.846c.46.44.72 1.05.72 1.688v3.901",
  stroke: "#000",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.235 17.878h14.538M12.235 12.352h14.538",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 1.6,
  strokeLinecap: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m32.693 20.657 3.447 4.575m-10.619 8.301-4.84.006c-.445 0-.706-.346-.583-.774l1.248-4.33c.059-.205.2-.402.394-.548l15.449-11.641c.402-.303.913-.304 1.14-.001l3.258 4.323c.228.302.087.793-.315 1.096l-15.75 11.87Z",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M26.263 3v6.235h6.624",
  stroke: "#000",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"120\" height=\"120\" viewBox=\"0 0 44 44\" fill=\"none\">\r\n  <path d=\"M33.2768 32.7859V38.8495C33.2768 39.2629 33.1402 39.6593 32.897 39.9516C32.6538 40.2439 32.324 40.4081 31.9801 40.4081H7.2967C6.58055 40.4081 6 39.7103 6 38.8495V4.55867C6 3.69784 6.58055 3 7.2967 3L25.8816 3C26.4845 3 27.064 3.23284 27.4992 3.64992L32.5564 8.49592C33.0166 8.93689 33.2768 9.54663 33.2768 10.184V14.0851\" stroke=\"#000000\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n  <path d=\"M12.2349 17.8776L26.7728 17.8776\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.6\" stroke-linecap=\"round\"/>\r\n  <path d=\"M12.2349 12.3518L26.7728 12.3518\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.6\" stroke-linecap=\"round\"/>\r\n  <path d=\"M32.6926 20.6569L36.1403 25.2322M25.5213 33.5331L20.6817 33.5392C20.2362 33.5398 19.9751 33.1932 20.0984 32.7652L21.3458 28.4358C21.405 28.2302 21.5468 28.033 21.7399 27.8874L37.1886 16.246C37.5908 15.9429 38.1015 15.9423 38.3293 16.2446L41.5874 20.5683C41.8152 20.8705 41.6738 21.3613 41.2716 21.6644L25.5213 33.5331Z\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n  <path d=\"M26.2627 2.99988V9.23457H32.8871\" stroke=\"#000000\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/sign.46c74a0670dbc4f4374111e14aa16148.svg"),
        {
          React: SvgSign,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      